import {
  type OrderGetOrderDetailsOrderItemReadDto,
  type OrderItemDetailsReadDto,
  type WorkflowPostponedActivityReadDtoActivityEnum,
} from "@/config/apiClient";

// Compare if the postponed activities does not contain the given activities
export const hasNoPostponedActivities = (
  orderItem: OrderItemDetailsReadDto | OrderGetOrderDetailsOrderItemReadDto,
  forbiddenActivities: WorkflowPostponedActivityReadDtoActivityEnum[]
): boolean => {
  const currentActivities = orderItem?.Workflow?.PostponedActivities;

  if (!currentActivities || currentActivities.length === 0) {
    return true;
  }

  return !currentActivities.some((item) =>
    forbiddenActivities.includes(item.activity)
  );
};
